export default {
    title: 'Xem tổng hợp hướng dẫn theo hoạt động 매일국어 T',
};
